import type { PostParticulierSearchResponse } from "@/app/api/cat/particulier-search/route";
import type { CatParticulierSearchBody } from "@/lib/schemas/cat/particulier-search";
import { useMutation } from "@tanstack/react-query";

const ENDPOINT = "/api/cat/particulier-search";

export function useCatParticulierSearchMutation() {
  return useMutation({
    mutationFn: async (body: CatParticulierSearchBody) => {
      const response = await fetch(ENDPOINT, {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });

      if (response.status === 401) {
        throw new Error("Unauthorized");
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Client error");
      }

      return response.json() as Promise<PostParticulierSearchResponse>;
    },
  });
}
